import { Navigate, createBrowserRouter } from "react-router-dom";
import App from "../App";
import CheckoutPage from "../Pages/CheckoutPage/CheckoutPage";
import DesignGuidePage from "../Pages/DesignGuidePage/DesignGuidePage";
import FaqPage from "../Pages/FaqPage/FaqPage";
import LoginPage from "../Pages/HomePage/HomePage";
import IdentityLoginPage from "../Pages/IdentityLoginPage/IdentityLoginPage";
import MasterpassPage from "../Pages/MasterpassPage/MasterpassPage";
import PaymentFramePage from "../Pages/PaymentFramePage/PaymentFramePage";
import PaymentsPage from "../Pages/PaymentsPage/PaymentsPage";
import VerifyPage from "../Pages/VerifyPage/VerifyPage";
import AccsessRoute from "./AccsessRoute";
import ProtectedRoute from "./ProtectedRoute";
import RefCodeProtectedRoute from "./RefCodeProtectedRoute";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "",
        element: (
          <AccsessRoute>
            <LoginPage />
          </AccsessRoute>
        ),
      }, {
        path: "identity-login",
        element: (
          <AccsessRoute>
            <IdentityLoginPage />
          </AccsessRoute>
        ),
      },
      {
        path: "payments",
        element: (
          <ProtectedRoute>
            <PaymentsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "checkout",
        element: (
          <RefCodeProtectedRoute>
            <CheckoutPage />
          </RefCodeProtectedRoute>
        ),
      },
      {
        path: "checkout/masterpass-init",
        element: <MasterpassPage />,
      },
      {
        path: "payment-frame",
        element: (
          <ProtectedRoute>
            <PaymentFramePage />
          </ProtectedRoute>
        ),
      },
      {
        path: "auth/verify",

        element: <VerifyPage />,
      },
      { path: "sss", element: <FaqPage /> },
      { path: "design-guide", element: <DesignGuidePage /> },
      { path: "*", element: <Navigate to="/" /> },
    ],
  },
]);
